import { define } from 'wicked-elements'
import 'lazysizes'

/**
 * Notes about `group-async` class:
 * 
 * Tailwind uses the `group` class to wrap containers
 * so that child elements can have states such as hover
 * when the parent container is hovered. There are some
 * instances on the Carnegie site where we only want 
 * the hover states applied once the child elements have
 * loaded. To handle this, we add a `group-async` class
 * to containers, and then when media within these 
 * elements have loaded, we add the `group` class so 
 * hover effects can be applied.
 */

/**
 * Image Loading
 * 
 * Lazyloading handled using the lazysizes library
 */

document.addEventListener('lazyloaded', (e) => {
  const $parent = e.target.closest('.group-async')

  // Add `group` class to the parent `group-async`
  if ($parent) {
    $parent.classList.add('group')
  }

  // Add orientation class in case needed for styling
  const $figure = e.target.closest('figure.cmoa-image')
  if ($figure) {
    const orientation = e.target.naturalHeight >= e.target.naturalWidth ? 'portrait' : 'landscape'
    $figure.classList.add(`orientation-${orientation}`)
  }
})

/**
 * Video loading
 */

define('[data-component~="video-load"]', {
  init () {
    this.$parent = this.element.closest('.group-async')
  },
  oncanplay(e) {
    // Add `video-canplay` class to the video itself
    e.target.classList.add('video-canplay')

    // Add `group` class to the parent `group-async`
    if (this.$parent) {
      this.$parent.classList.add('group')
    }
  }
})